import React from "react";

function SquareMetersIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 10H6.672M4 16H6.672M4 22H6.672M10 28V25.376M16 28V25.376M22 28V25.376M4 4H14.6667V17.3333H28V28H4V4Z"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SquareMetersIcon;
